import { Button, Card } from '@george-labs.com/design-system';
import type { FC } from 'react';
import { useEffect } from 'react';
import classNames from 'classnames';

import { t } from '@luna/i18n';
import type { PublicTemporaryMessage } from '@api-client/temporary-messages';

import { getSeverityCardColor } from './TemporaryMessagesHeaderService';
import { trackTemporaryMessageDisplayed } from './TemporaryMessageTrackingService';
import { TemporaryMessageContent } from './TemporaryMessageContent';
import style from './TemporaryMessagesHeader.module.scss';

interface Props {
    message: PublicTemporaryMessage;
    onClose(messageId: string): void;
    openDetail(): void;
    trigger: string | undefined;
}

export const TemporaryMessagesHeader: FC<Props> = ({ message, onClose, openDetail, trigger }) => {
    useEffect(() => {
        trackTemporaryMessageDisplayed(message, trigger);
    }, []);

    return (
        <Card
            data-cy="temporary-message-list"
            className={classNames(
                'fixed-top justify-content-center m-0 rounded-0 border-0',
                style.temporaryMessageHeader,
            )}
            color={getSeverityCardColor(message.severity)}
            padding={Card.PADDING.NONE}
            useCardBody={false}
        >
            <div className="g-container pt-1" data-cy={`temporary-message-${message.severity}`}>
                <TemporaryMessageContent
                    message={message}
                    onClose={onClose}
                    afterMessage={
                        <div className="text-center  mb-1">
                            <Button
                                data-cy="show-temporary-message-detail"
                                variant={Button.VARIANT.TERTIARY}
                                size={Button.SIZE.SMALL}
                                fullWidth={Button.FULL_WIDTH.NEVER}
                                onClick={openDetail}
                            >
                                {t('temporaryMessages.showAllButton')}
                            </Button>
                        </div>
                    }
                />
            </div>
        </Card>
    );
};
